import MainContainer from "../../components/MainContainer";
import { headerDataImmo } from "../../data/modules/logistic-header";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect, useContext } from "react";
import { Download } from '@mui/icons-material';

import { Grid, Paper } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { InsertDriveFile } from "@material-ui/icons";
import Spacer from "../../components/Spacer";
import InventoryOthersTable from "./InventoryOthersTable";
import InventoryToStock from "./InventoryToStock";
import InventoryAffectation from "./InventoryAffectation";
import InventoryAffectationSheet from "./InventoryAffectationSheet";
import InventoryValidation from "./InventoryValidation";
import InventoryDetentionSheet from "./InventoryDetentionSheet";
import ExportExcel from "./ExportExcel";
import InventoryService from "../../services/InventoryService";
import UserService from "../../services/UserService";
import ImmobilisationService from "../../services/ImmobilisationService";
import FilterValidationOption from "../../components/FilterValidationOption";

import { hasPrivilege } from "../../utils/privilege";
import { userDetailContext } from "../../App";
import InventoryInventaire from "./InventoryInventaire";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  style1: {
    fontSize: "5em",
  },
}));

function InventoryOthersList() {
  const contextData = useContext(userDetailContext);
  const classes = useStyles();
  const [isFilter, setIsFilter] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [isImputChanged, setIsImputChanged] = useState(false);

  // ✅ State React pour la direction (rempli via onChangeDirection)
  const [directionFilter, setDirectionFilter] = useState(
    localStorage.getItem("logistics_manager") || ""
  );

  var myCurrentDate = new Date();

  var date =
    myCurrentDate.getFullYear() +
    "-" +
    (myCurrentDate.getMonth() + 1) +
    "-" +
    myCurrentDate.getDate() +
    "-" +
    myCurrentDate.getHours() +
    "-" +
    myCurrentDate.getMinutes() +
    "-" +
    myCurrentDate.getSeconds();

  const [dataToExport, setDataToExport] = useState([]);
  const [dataDetenteurExport, setdataDetenteurExport] = useState([]);
  const [dataImmo, setDataImmo] = useState([]);
  const [rows, setRows] = useState([]);
  const [fileName, setFileName] = useState("Inventaire enregistré le " + date);
  const [filenameDetenteur, setfilenameDetenteur] = useState("detenteur_immo_" + date);
  const [isOpenStock, setIsOpenStock] = useState(false);
  const [isOpenAffectedTo, setIsOpenAffectedTo] = useState(false);
  const [isOpenAffectedInventory, setIsOpenAffectedInventory] = useState(false);
  const [isOpenAffectedSheet, setIsOpenAffectedSheet] = useState(false);
  const [isOpenDetentionSheet, setIsOpenDetentionSheet] = useState(false);
  const [isOpenFirstValidation, setIsFirstValidation] = useState(false);
  const [excelExport, setExportToExcelFile] = useState(0);

  const wscols = [
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 15 },
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 10 },
    { wch: 25 },
  ];

  const wscolsDetenteur = [
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 45 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
  ];

  useEffect(() => {
    InventoryService.exportExcel().then((result) => {
      if (result && result.data) {
        setDataToExport(result.data);
      }
    });
    InventoryService.exportDetenteurExcel().then((result) => {
      if (result && result.data) {
        setdataDetenteurExport(result.data);
      }
    });
  }, []);

  function handleClickStock() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    console.log("xhr : ", allImmoSelected);
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    setIsOpenStock(true);
  }

  function handleCloseDialogStock() {
    setIsOpenStock(false);
  }

  function handleClickAffectedTo() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    UserService.getAllUserActive().then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
      }
    });
    setIsOpenAffectedTo(true);
  }

  function handleClickInventory() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    setIsOpenAffectedInventory(true);
  }

  function handleClickAffectedSheet() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");

    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });

    UserService.getAllUserActive().then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
      }
    });

    setIsOpenAffectedSheet(true);
  }

  function handleClickDetentionSheet() {
    setIsOpenDetentionSheet(true);
  }

  // ✅ handleSubmit : on déclenche le rechargement du tableau
  //    La direction est déjà dans le state directionFilter
  const handleSubmit = (e) => {
    e.preventDefault();

    setFilterCount((count) => count + 1);
    localStorage.setItem("changedImputFilterValidation", 0);

    console.log("handleSubmit → direction envoyée =", directionFilter);
  };

  const Refresh = (e) => {
    e.preventDefault();
    localStorage.removeItem("name_materiel");
    localStorage.removeItem("code_immo");
    localStorage.removeItem("state");
    localStorage.removeItem("logistics_manager");
    localStorage.removeItem("status1");
    localStorage.removeItem("status2");
    localStorage.removeItem("changedImputFilterValidation");
    localStorage.removeItem("mes_materiels");

    localStorage.setItem("name_materiel", "");
    localStorage.setItem("code_immo", "");
    localStorage.setItem("state", "");
    localStorage.setItem("logistics_manager", "");
    localStorage.setItem("status1", "");
    localStorage.setItem("status2", "");
    localStorage.setItem("changedImputFilterValidation", "");
    localStorage.setItem("mes_materiels", "false");

    // ✅ Reset du state React (et la prop `value` du filtre va aussi le reset)
    setDirectionFilter("");

    window.location.reload();
  };

  const handleExportToExcel = () => {
    setExportToExcelFile(excelExport + 1);
  };

  function handleClickValidatedTo() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    setIsFirstValidation(true);
  }

  function handleCloseDialogAffectedTo() {
    setIsOpenAffectedTo(false);
  }

  function handleCloseDialogAffectedInventory() {
    setIsOpenAffectedInventory(false);
  }

  function handleCloseDialogValidation() {
    setIsFirstValidation(false);
  }

  function handleCloseDialogDetentionSheet() {
    setIsOpenDetentionSheet(false);
  }

  function handleCloseDialogAffectationSheet() {
    setIsOpenAffectedSheet(false);
  }

  return (
    <MainContainer {...headerDataImmo}>
      <Grid container item xs={12}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickInventory}
          style={{ fontWeight: 600 }}
        >
          Inventaire
        </Button>
        <Spacer x={2} />
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickAffectedTo}
          style={{ fontWeight: 600, backgroundColor: "yellowgreen" }}
        >
          AFFECTER
        </Button>
        <Spacer x={2} />
        <Button
          variant="contained"
          onClick={Refresh}
          style={{ fontWeight: 600, backgroundColor: "darkred", color: "white" }}
        >
          Réinitialiser le filtre
        </Button>
        <Spacer x={2} />

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ fontWeight: 600 }}
        >
          Filtrer
        </Button>
        <Spacer x={2} />

        {/* ✅ Le composant remonte la direction au parent via onChangeDirection */}
        <FilterValidationOption
          type={1}
          value={directionFilter}
          onChangeDirection={setDirectionFilter}
        />

        <Button
          onClick={() => {
            handleExportToExcel();
          }}
          variant="contained"
          color="inherit"
          sx={{
            backgroundColor: "#424242",
            color: "#fff",
            fontWeight: 700,
            "&:hover": {
              backgroundColor: "#212121",
            },
          }}
        >
          <Download sx={{ mr: 1 }} />
          Exporter
        </Button>

        <Spacer x={2} />

        <InventoryToStock
          dataImmo={dataImmo}
          open={isOpenStock}
          closeDialog={handleCloseDialogStock}
        />

        <InventoryAffectation
          dataImmo={dataImmo}
          rows={rows}
          open={isOpenAffectedTo}
          closeDialog={handleCloseDialogAffectedTo}
          fullWidth
          maxWidth="sm"
        />

        <InventoryInventaire
          dataImmo={dataImmo}
          rows={rows}
          open={isOpenAffectedInventory}
          closeDialog={handleCloseDialogAffectedInventory}
          fullWidth
          maxWidth="sm"
        />

        <InventoryAffectationSheet
          dataImmo={dataImmo}
          rows={rows}
          open={isOpenAffectedSheet}
          closeDialog={handleCloseDialogAffectationSheet}
          fullWidth
          maxWidth="sm"
        />

        <InventoryValidation
          dataImmo={dataImmo}
          open={isOpenFirstValidation}
          closeDialog={handleCloseDialogValidation}
        />

        <InventoryDetentionSheet
          dataImmo={dataImmo}
          rows={rows}
          open={isOpenDetentionSheet}
          closeDialog={handleCloseDialogDetentionSheet}
          fullWidth
          maxWidth="sm"
        />
      </Grid>

      <Spacer y={2} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            {/* ✅ On passe directionFilter (state React) */}
            <InventoryOthersTable
              filterCount={filterCount}
              excelExport={excelExport}
              nameMateriel={localStorage.getItem("name_materiel")}
              codeImmo={localStorage.getItem("code_immo")}
              stateFilter={localStorage.getItem("state")}
              directionFilter={directionFilter}
            />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
export default InventoryOthersList;